<div class="days-wrapper">
	<lib-ui-card clipPathT disablePadding class="h-40 flex-none">
	</lib-ui-card>
	<lib-ui-card disablePadding class="flex-1">
		<app-chart-log-days></app-chart-log-days>
	</lib-ui-card>
	<lib-ui-card disablePadding class="h-40 flex-none">
		<app-chart-vape-sum></app-chart-vape-sum>
	</lib-ui-card>
	<lib-ui-card disablePadding class="h-40 flex-none">
		<app-chart-vape-sum mgType="thcTotal"></app-chart-vape-sum>
	</lib-ui-card>
</div>